export default {
  data () {
    return {
      bgIn: {
        classes: 'fadeInLeft',
        delay: 0,
        duration: 1000
      },
      logoIn: {
        classes: 'fadeInLeft',
        delay: 1500,
        duration: 1000
      },
      textIn: {
        classes: 'fadeInLeft',
        delay: 1000,
        duration: 1000
      },
      detailTextIn: {
        classes: 'fadeInRight',
        delay: 700,
        duration: 1000
      },
      lineIn: {
        classes: 'fadeInRight',
        delay: 800,
        duration: 1000
      },
      detailText1In: {
        classes: 'fadeInRight',
        delay: 800,
        duration: 1000
      },
      detailText2In: {
        classes: 'fadeInRight',
        delay: 900,
        duration: 1000
      },
      detailText3In: {
        classes: 'fadeInRight',
        delay: 1000,
        duration: 1000
      },
      left: false,
      right: false
    }
  },
  watch: {
  },
  props: ['slideHandler', 'landscape'],
  methods: {
    showArrow: function (direction) {
      this[direction] = true
    },
    hideArrow: function (direction) {
      this[direction] = false
    },
    slide: function (direction) {
      this.slideHandler(direction)
    },
    routeTo: function (pathName) {
      this.$router.push({ name: pathName })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Detail/Config.js